import styled from 'styled-components'

import type { LandingPageContentBlock } from '@/types/landing-page'

import { Grid } from '@/components/blocks/DesignSystem/Grid'
import { GridBlock } from '@/components/blocks/DesignSystem/GridBlock'
import { SpacerBlock } from '@/components/blocks/DesignSystem/Spacer'

const StyledPageWrapper = styled.div`
  padding-top: var(--grid-72);
`

const renderBlock = (record: LandingPageContentBlock) => {
  switch (record.__typename) {
    case 'GridRecord':
      return <Grid key={record.id} record={record} />
    case 'GridBlockRecord':
      return <GridBlock key={record.id} record={record} />
    case 'SpacerRecord':
      return <SpacerBlock key={record.id} record={record} />
  }
}

type LandingPageContentProps = {
  content: LandingPageContentBlock[]
}

export const LandingPageContent = ({ content }: LandingPageContentProps) => {
  return <StyledPageWrapper>{(content ?? []).map((record) => renderBlock(record))}</StyledPageWrapper>
}
